module.exports = __webpack_public_path__ + "houseWithLessHills-3WEsiMY.png";